<button
  type="button"
  [class]="_buttonClass()"
  [disabled]="_isDisabled()"
  [attr.aria-label]="config().processing ? config().label : null"
  [attr.aria-busy]="config().processing ? true : null"
  (click)="_onClick()"
>
  <span class="cads-app-button__inner">
    @if (config().processing) {
      <span class="cads-app-button__spinner" aria-hidden="true">
        <cads-processing-spinner [config]="_processingSpinnerConfig" />
      </span>
    } @else {
      @if (_leadingIconConfig(); as leading) {
        <span class="cads-app-button__icon" aria-hidden="true">
          <cads-icon-view-bit [config]="leading" />
        </span>
      }
      <span class="cads-app-button__label">{{ config().label }}</span>
      @if (_trailingIconConfig(); as trailing) {
        <span class="cads-app-button__icon" aria-hidden="true">
          <cads-icon-view-bit [config]="trailing" />
        </span>
      }
    }
  </span>
</button>
